import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'priceMode',pure:false })
export class PriceModePipe implements PipeTransform {
  constructor(private translateService:TranslateService){

  }
  transform(price, priceMode) {
    const display:string = priceMode === 'VATExcluded' ? this.translateService.instant('tax.VATExcludedShort'): '';
    return price + " " + display;
  }
}